export default __webpack_public_path__ + "static/media/Tem_Prompt-Modal-BG.176fb354.png";